__turbopack_context__.v({
  "accordionBox": "NavQuickLinks-module-scss-module__o8OYiG__accordionBox",
  "accordionImg": "NavQuickLinks-module-scss-module__o8OYiG__accordionImg",
  "accordionItem": "NavQuickLinks-module-scss-module__o8OYiG__accordionItem",
  "accordionWrapper": "NavQuickLinks-module-scss-module__o8OYiG__accordionWrapper",
  "bannerCategoryWrapper": "NavQuickLinks-module-scss-module__o8OYiG__bannerCategoryWrapper",
  "categoryWrapper": "NavQuickLinks-module-scss-module__o8OYiG__categoryWrapper",
  "exhibitionsRulerImage": "NavQuickLinks-module-scss-module__o8OYiG__exhibitionsRulerImage",
  "exhibitionsSwiper": "NavQuickLinks-module-scss-module__o8OYiG__exhibitionsSwiper",
  "exhibitionsWithImageWrapper": "NavQuickLinks-module-scss-module__o8OYiG__exhibitionsWithImageWrapper",
  "flexBox": "NavQuickLinks-module-scss-module__o8OYiG__flexBox",
  "headerBox": "NavQuickLinks-module-scss-module__o8OYiG__headerBox",
  "innerWrapper": "NavQuickLinks-module-scss-module__o8OYiG__innerWrapper",
  "open": "NavQuickLinks-module-scss-module__o8OYiG__open",
  "rectangleCategoryWrapper": "NavQuickLinks-module-scss-module__o8OYiG__rectangleCategoryWrapper",
  "rectangleFlexBox": "NavQuickLinks-module-scss-module__o8OYiG__rectangleFlexBox",
  "rectangleHeaderBox": "NavQuickLinks-module-scss-module__o8OYiG__rectangleHeaderBox",
  "rectangleInnerWrapper": "NavQuickLinks-module-scss-module__o8OYiG__rectangleInnerWrapper",
  "rulerImage": "NavQuickLinks-module-scss-module__o8OYiG__rulerImage",
  "sticky": "NavQuickLinks-module-scss-module__o8OYiG__sticky",
  "storiesSwiper": "NavQuickLinks-module-scss-module__o8OYiG__storiesSwiper",
  "storiesWithImageWrapper": "NavQuickLinks-module-scss-module__o8OYiG__storiesWithImageWrapper",
  "svgImage": "NavQuickLinks-module-scss-module__o8OYiG__svgImage",
  "swiperBox": "NavQuickLinks-module-scss-module__o8OYiG__swiperBox",
  "textFlexBox": "NavQuickLinks-module-scss-module__o8OYiG__textFlexBox",
  "verticalWrapper": "NavQuickLinks-module-scss-module__o8OYiG__verticalWrapper",
});
